import React, { FC, ReactNode } from "react";

import useUserAgent from "../../../hooks/useUserAgent";
import Frame from "../Frame";
import styles from "./FlightDetailsAncillaryItemLayoutAlt.module.css";
import flights_web_condensed_extras_fd_mdot from "../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

/* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
const FlightDetailsAncillaryItemLayoutAlt: FC<{
  icon: ReactNode;
  recommendation?: ReactNode;
  leftColumnContent: ReactNode;
  rightColumnContent: ReactNode;
  alignIconCenter?: boolean;
  extraTestId?: string;
}> = ({ icon, recommendation, leftColumnContent, rightColumnContent, alignIconCenter = false, extraTestId }) => {
  const { isMobile } = useUserAgent();

  return (
    <div>
      {recommendation && (
        <Frame pb={1} pt={1}>
          {recommendation}
        </Frame>
      )}
      <Frame
        direction="row"
        alignItems={alignIconCenter ? "center" : undefined}
        attributes={{ "data-testid": `flight_details_ancillary_item_layout_${extraTestId}` }}
      >
        <div className={styles.iconWrapper}>{icon}</div>
        <Frame
          direction={isMobile && !flights_web_condensed_extras_fd_mdot.trackWithDefaultStage() ? "column" : "row"}
          alignItems={isMobile && !flights_web_condensed_extras_fd_mdot.trackWithDefaultStage() ? undefined : "center"}
          className={styles.mainBlock}
        >
          <div className={styles.content} data-testid="flight_details_ancillary_item_layout_content">
            {leftColumnContent}
          </div>
          {rightColumnContent}
        </Frame>
      </Frame>
    </div>
  );
};

export default FlightDetailsAncillaryItemLayoutAlt;
/* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
